let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9fG7I"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("eCKto")]).then(() => parcelRequire('lt04m'));